import { render, staticRenderFns } from "./v-address-field.vue?vue&type=template&id=8145d4a0&"
import script from "./v-address-field.vue?vue&type=script&lang=js&"
export * from "./v-address-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports